<template>
  <textarea
    v-if="type === 'textarea'"
    :id="id"
    class="textarea"
    :type="type"
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :maxlength="maxLength"
    @input="onInput"
    @blur="onBlur"
  />
  <input
    v-else
    :id="id"
    class="input"
    :type="type"
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :maxlength="maxLength"
    autocomplete="off"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script>
  export default {
    name: "Input",
    props: {
      id: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: "text"
      },
      value: [Number, String],
      disabled: Boolean,
      readonly: Boolean,
      maxLength: Number
    },
    methods: {
      onInput(event) {
        this.$emit("change", event.target.value);
      },
      onBlur(event) {
        this.$emit("blur", event.target.value);
      }
    }
  };
</script>

<style lang="scss">
  .input,
  .textarea {
    padding: 10px;
    border: $border;
    border-radius: $radius;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .textarea {
    min-height: 150px;
  }
</style>
